import { getCookies } from "../helpers/commonCookiesFunctions";
import { DEFAULT_VALUE } from "../types/LoggingTypes";
export class SessionDimensions {
    constructor() {
        this._sessionId = DEFAULT_VALUE;
        this._sessionSearchId = DEFAULT_VALUE;
        this._sessionMedium = 'web_open';
        this._sessionSource = 'opensooq';
        this._sessionCampaign = 'direct_web_open';
    }
    static getInstance() {
        if (!SessionDimensions.instance) {
            SessionDimensions.instance = new SessionDimensions();
        }
        return SessionDimensions.instance;
    }
    get sessionId() {
        return this._sessionId;
    }
    set sessionId(_sessionId) {
        this._sessionId = _sessionId;
    }
    get sessionSearchId() {
        return this._sessionSearchId;
    }
    set sessionSearchId(_sessionSearchId) {
        this._sessionSearchId = _sessionSearchId;
    }
    get sessionLife() {
        if (getCookies().tgtTimestamp) {
            const sessionLifeTime = Math.floor(((Date.now() / 1000) - getCookies().tgtTimestamp));
            if (sessionLifeTime < 0)
                return "1";
            return sessionLifeTime.toString();
        }
        return DEFAULT_VALUE;
    }
    get sessionMedium() {
        return this._sessionMedium;
    }
    set sessionMedium(sessionMedium) {
        this._sessionMedium = sessionMedium;
    }
    get sessionSource() {
        return this._sessionSource;
    }
    set sessionSource(sessionSource) {
        this._sessionSource = sessionSource;
    }
    get sessionCampaign() {
        return this._sessionCampaign;
    }
    set sessionCampaign(sessionCampaign) {
        this._sessionCampaign = sessionCampaign;
    }
}
